module.exports = __webpack_public_path__ + "img/plane-right-desktop.f35271e5.svg";